/* Auto-zoom product card images that have a lot of empty background.
   A small copy of each image is scanned to find where the product actually sits,
   then the card image is scaled (CSS `scale` + `translate`, which stack with the
   hover `transform`) so the product fills roughly FILL of the frame. */
(function () {
  window.aljusTrim = true;

  var SELECTOR = [
    '.aljus-ccard__image:not(.aljus-ccard__image--hover):not(.placeholder-svg)',
    '.aljus-card__image:not(.placeholder-svg)',
    '.card__media .media > img:first-child',
    // Product page gallery + its thumbnails
    '.product__media-wrapper .product-media-container.media-type-image .media > img',
    '.product__media-wrapper .thumbnail > img'
  ].join(',');

  var FILL = 0.85;        // share of the frame the product should fill
  var MAX_ZOOM = 3;       // never zoom more than this (keeps images sharp)
  var MIN_ZOOM = 1.1;     // below this, leave the image as it is
  // How much of the frame the product already fills decides how hard it is zoomed:
  // at or below SMALL it gets the full zoom, at or above BIG none, eased in between
  // so medium-size products only get a light zoom.
  var SMALL = 0.15;
  var BIG = 0.6;
  var SAMPLE_WIDTH = 120; // width of the copy used for scanning
  var THRESHOLD = 28;     // colour difference that counts as "product"
  var CACHE_KEY = 'aljusTrim:v1';

  var cache = {};
  try { cache = JSON.parse(localStorage.getItem(CACHE_KEY)) || {}; } catch (e) {}
  var saveTimer;
  function saveCache() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      try { localStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch (e) {}
    }, 500);
  }

  var pending = {};
  var boxes = new WeakMap();

  function imageUrl(img) {
    var src = img.currentSrc || img.getAttribute('src');
    if (!src) return null;
    try { return new URL(src, location.href); } catch (e) { return null; }
  }

  function bgDistance(d, i, bg) {
    if (bg.transparent) return d[i + 3] < 16 ? 0 : 255;
    if (d[i + 3] < 16) return 0;
    return Math.max(Math.abs(d[i] - bg.r), Math.abs(d[i + 1] - bg.g), Math.abs(d[i + 2] - bg.b));
  }

  // Returns the product's bounding box as fractions of the image, or 0 when
  // the background is not a plain colour (e.g. room photos).
  function scan(image) {
    var w = image.naturalWidth, h = image.naturalHeight;
    if (!w || !h) return 0;
    var canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(image, 0, 0);
    var d = ctx.getImageData(0, 0, w, h).data;

    var corners = [0, (w - 1) * 4, (h - 1) * w * 4, ((h - 1) * w + w - 1) * 4];
    var transparent = corners.every(function (i) { return d[i + 3] < 16; });
    var bg = { transparent: transparent, r: 0, g: 0, b: 0 };
    if (!transparent) {
      corners.forEach(function (i) { bg.r += d[i] / 4; bg.g += d[i + 1] / 4; bg.b += d[i + 2] / 4; });
      var uniform = corners.every(function (i) { return bgDistance(d, i, bg) < THRESHOLD; });
      if (!uniform) return 0;
    }

    var x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        if (bgDistance(d, (y * w + x) * 4, bg) > THRESHOLD) {
          if (x < x0) x0 = x;
          if (x > x1) x1 = x;
          if (y < y0) y0 = y;
          if (y > y1) y1 = y;
        }
      }
    }
    if (x1 < 0) return 0;
    return { x0: x0 / w, y0: y0 / h, x1: (x1 + 1) / w, y1: (y1 + 1) / h, ar: w / h };
  }

  function analyse(url, done) {
    var key = url.pathname;
    if (key in cache) return done(cache[key]);
    if (pending[key]) return pending[key].push(done);
    pending[key] = [done];

    var small = new URL(url.href);
    small.searchParams.set('width', SAMPLE_WIDTH);
    small.searchParams.delete('height');
    small.searchParams.delete('crop');

    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.decoding = 'async';
    probe.onload = function () {
      var box;
      try {
        box = scan(probe);
        cache[key] = box;
        saveCache();
      } catch (e) {
        box = 0; // canvas blocked (CORS) – leave the image alone
      }
      pending[key].forEach(function (fn) { fn(box); });
      delete pending[key];
    };
    probe.onerror = function () {
      pending[key].forEach(function (fn) { fn(0); });
      delete pending[key];
    };
    probe.src = small.href;
  }

  function reset(img) {
    img.style.scale = '';
    img.style.translate = '';
  }

  function apply(img) {
    var box = boxes.get(img);
    var frame = img.parentElement;
    var W = img.offsetWidth, H = img.offsetHeight;
    if (!box || !frame || !W || !H) return reset(img);

    var fit = getComputedStyle(img).objectFit;
    if (fit !== 'contain' && fit !== 'cover') return reset(img);

    // Where the product is drawn inside the <img> box right now
    var s = fit === 'cover' ? Math.max(W / box.ar, H) : Math.min(W / box.ar, H);
    var dw = box.ar * s, dh = s;
    var ox = (W - dw) / 2, oy = (H - dh) / 2;
    var cx0 = Math.max(0, ox + box.x0 * dw), cx1 = Math.min(W, ox + box.x1 * dw);
    var cy0 = Math.max(0, oy + box.y0 * dh), cy1 = Math.min(H, oy + box.y1 * dh);
    var cw = cx1 - cx0, ch = cy1 - cy0;
    if (cw <= 0 || ch <= 0) return reset(img);

    var share = Math.max(cw / frame.offsetWidth, ch / frame.offsetHeight);
    var t = Math.max(0, Math.min(1, (BIG - share) / (BIG - SMALL)));
    var z = Math.min(1 + (FILL / share - 1) * t * t, MAX_ZOOM);
    if (z < MIN_ZOOM) return reset(img);

    var tx = z * (W / 2 - (cx0 + cx1) / 2);
    var ty = z * (H / 2 - (cy0 + cy1) / 2);
    img.style.scale = z.toFixed(3);
    img.style.translate = tx.toFixed(1) + 'px ' + ty.toFixed(1) + 'px';

    // Ask the browser for a sharper file to match the zoom
    if (img.srcset) {
      var wanted = Math.ceil(W * z);
      if (!img.dataset.trimSizes || +img.dataset.trimSizes < wanted) {
        img.dataset.trimSizes = wanted;
        img.sizes = wanted + 'px';
      }
    }
  }

  var resizeObserver = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) { apply(entry.target); });
  });

  // Lets the image show (it is kept invisible by CSS in theme.liquid until then)
  function reveal(img) {
    img.dataset.trimDone = '';
  }

  function track(img) {
    if (img.dataset.trim) return;
    img.dataset.trim = '1';
    var url = imageUrl(img);
    if (!url) return reveal(img);
    // Never keep an image hidden for long if the scan is slow
    var timer = setTimeout(function () { reveal(img); }, 2500);
    analyse(url, function (box) {
      clearTimeout(timer);
      if (box) {
        boxes.set(img, box);
        apply(img);
        resizeObserver.observe(img);
      }
      reveal(img);
    });
  }

  // Start scanning a little before cards scroll into view
  var viewObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      viewObserver.unobserve(entry.target);
      track(entry.target);
    });
  }, { rootMargin: '400px 0px' });

  function scanPage(root) {
    root.querySelectorAll(SELECTOR).forEach(function (img) {
      if (img.dataset.trimSeen) return;
      img.dataset.trimSeen = '1';
      // Cached images get zoomed straight away, before they appear
      var url = imageUrl(img);
      if (url && cache[url.pathname]) return track(img);
      viewObserver.observe(img);
    });
  }

  function init() {
    scanPage(document);
    // Cards added later (filters, sorting, load more, carousels)
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        scanPage(document);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
